import { COMPANY_CONFIG } from '../constants/companyConfig';
import jwtDecode from 'jwt-decode';
import { useAuth } from '../contexts/AuthContext';

const policyMakerService = (token) => ({
  getUserPoolId: async () => {
    if (!token) return null;

    const decoded = jwtDecode(token);
    const issuer = decoded?.iss;
    const userPoolId = issuer?.split('/')?.pop();
    return userPoolId;
  },

  getUserId: async () => {
    if (!token) return '';

    const decoded = jwtDecode(token);
    return decoded['cognito:username'] || '';
  },

  getAccessToken: async () => {
    return token || '';
  },

  getClientId: async () => {
    const clientId = COMPANY_CONFIG?.customerId;
    return clientId || '';
  },
});

export default policyMakerService;
